import { render } from "./maturation.vue?vue&type=template&id=38a80c00&scoped=true"
import script from "./maturation.vue?vue&type=script&lang=js"
export * from "./maturation.vue?vue&type=script&lang=js"

import "./maturation.vue?vue&type=style&index=0&id=38a80c00&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a80c00"]])

export default __exports__